import React, { FunctionComponent, ReactNode } from 'react';
import { useFilterContext } from '../hooks';
import * as Styled from './styled';

export interface FiltersWrapperProps {
  addNewEntryBtn?: React.ReactNode;
  children: ReactNode;
}

export const FiltersWrapper: FunctionComponent<FiltersWrapperProps> = ({ addNewEntryBtn, children }) => {
  const { loading, entries, activeFilters } = useFilterContext();

  if (!loading && !entries && Object.keys(activeFilters).length === 0) {
    return null;
  }

  return (
    <Styled.DataNavigationContainer spacing="small">
      <Styled.Controls>
        {children}
        {addNewEntryBtn}
      </Styled.Controls>
    </Styled.DataNavigationContainer>
  );
};

export default FiltersWrapper;
